export default __webpack_public_path__ + "static/media/show_01.22ba9524.png";